<template>
  <div class="mb-6">
    <div class="buttons is-centered" v-if="!showNote">
      <a class="button is-white" @click="addNote">
          <span class="icon icon--cart"><i class="fas fa-edit"></i></span>
          <span>{{ $t('orders.actions.addNote') }}</span>
      </a>
    </div>
    <div v-if="showNote">
      <h2 class="title is-size-5 pl-2">
        <span class="pl-2">{{ $t('orders.note') }}</span>
      </h2>
      <div class="box has-background-white-bis p-2">
        <div class="p-2">
          <div class="field">
            <textarea
                name="note"
                class="textarea"
                rows="2"
                v-model="note"
                :class="{'is-danger': errors.note.length}"
            ></textarea>
            <p class="help is-danger" v-for="error in errors.email">{{ error }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="buttons is-centered mt-3" v-if="showNote">
      <a class="button is-white" @click="removeNote">
          <span class="icon icon--cart"><i class="fas fa-trash"></i></span>
          <span>{{ $t('orders.actions.removeNote') }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import cartGetters from "../../../../store/web/cart/getter-types";
import cartActions from "../../../../store/web/cart/action-types";

export default {
  data() {
    return {
      note: null,
      showNote: false,
    }
  },
  mounted() {
    this.note = this.$store.getters['cart/' + cartGetters.GET_NOTE];
    if (this.note) {
      this.addNote();
    }
  },
  computed: {
    errors() {
      return this.$store.getters['cart/' + cartGetters.GET_ERRORS];
    }
  },
  methods: {
    addNote() {
      this.showNote = true;
    },
    removeNote() {
      this.note = null;
      this.showNote = false;
    }
  }
}
</script>
